const ThemeColors = cc.Enum({
    COLOR_MAIN: 1,
    COLOR_LABEL: 2,
    COLOR_BG: 3
});
const ThemeLabelType = cc.Enum({
    SMALL: 1,
    MEDIUM: 2,
    BIG: 3
});

const ThemeController = require('./ThemeController');

cc.Class({
    extends: cc.Component,

    properties: {
        target: cc.Label,
        themeColor: {
            type: ThemeColors,
            default: ThemeColors.COLOR_MAIN,
            notify: function() {
                this.themeUpdate();
            }
        },
        labelType: {
            type: ThemeLabelType,
            default: ThemeLabelType.SMALL,
            notify: function() {
                this.themeUpdate();
            }
        },
        syncHeightWithSize: {
            default: false,
            notify: function() {
                if (this.syncHeightWithSize) {
                    this.syncMinHeightWithSize = false;
                }
                this.themeUpdate();
            }
        },
        syncMinHeightWithSize: {
            default: true,
            notify: function() {
                if (this.syncMinHeightWithSize) {
                    this.syncHeightWithSize = false;
                }
                this.themeUpdate();
            }
        },
    },

    onLoad () {
        const themeController = cc.find('PSUIInitializer/PSUI/ThemeController').getComponent('ThemeController');

        themeController.register(this);
    },

    themeUpdate () {
        if (CC_EDITOR) {
            cc.find('PSUI/ThemeController').getComponent(ThemeController).save();
        }
        if (!this.target) {
            return;
        }
        let color;
        switch(this.themeColor) {
            case ThemeColors.COLOR_MAIN:
                color = ThemeController.THEME_COLOR_MAIN
                break;
            case ThemeColors.COLOR_LABEL:
                color = ThemeController.THEME_COLOR_LABEL;
                break;
            case ThemeColors.COLOR_BG:
                color = ThemeController.THEME_COLOR_BG
                break;
        }

        this.target.node.color = color;
        this.target.node.opacity = color.a;

        let font;
        let fontSize;
        switch(this.labelType) {
            case ThemeLabelType.SMALL:
                font = ThemeController.THEME_FONT_LIGHT;
                fontSize = ThemeController.THEME_FONT_SIZE_SMALL;
                break;
            case ThemeLabelType.MEDIUM:
                font = ThemeController.THEME_FONT_MEDIUM;
                fontSize = ThemeController.THEME_FONT_SIZE_MEDIUM;
                break;
            case ThemeLabelType.BIG:
                font = ThemeController.THEME_FONT_MEDIUM;
                fontSize = ThemeController.THEME_FONT_SIZE_BIG;
                break;
        }
        this.target.font = font;
        this.target.fontSize = fontSize;
        this.target.lineHeight = fontSize;

        this.target.node.setScale(0.5, 0.5);

        const minHeight = fontSize * 1.2;
        if (this.syncHeightWithSize) {
            this.target.node.height = minHeight;
        } else if (this.syncMinHeightWithSize) {
            if (this.target.node.height < fontSize) {
                this.target.node.height = minHeight;
            }
        }
    }
});
